//Gift Option
const donationAmountButtons = document.querySelectorAll("#gift-option-buttons button") as NodeListOf<HTMLButtonElement>;
const textAmountInput = document.getElementById("GiftOptionAmount") as HTMLInputElement;
const giftOptionValidationMessage = document.getElementById("giftOptionValidationMessage");

if (donationAmountButtons) {
    donationAmountButtons.forEach(button => {
        button.addEventListener("click", () => {
            if (textAmountInput) {
                textAmountInput.value = button.dataset.giftOptionAmount;
            }
            donationAmountButtons.forEach(button => button.classList.remove("selected-button"));
            button.classList.add("selected-button");
            giftOptionValidationMessage.classList.add("hide");
        })
    })
}

if (textAmountInput) {
    textAmountInput.addEventListener("input", () => {
        donationAmountButtons.forEach(button => {
            //Add the 'selected' class to the button matching the text input. Otherwise, remove the 'selected' class.
            if (textAmountInput.value == button.dataset.giftOptionAmount) {
                button.classList.add("selected-button");
            }
            else {
                button.classList.remove("selected-button");
            }

            giftOptionValidationMessage.classList.add("hide");
        });
    })
}

const addGiftDonationToCartCta = document.getElementById("giftOptionAddToCartCta");
if (addGiftDonationToCartCta) {
    addGiftDonationToCartCta.addEventListener("click", () => {
        if (textAmountInput.value == "" || !inputValueGreaterThanZero(textAmountInput)) {
            //If there is no amount, or an invalid amount, then show validation message.
            giftOptionValidationMessage.classList.remove("hide");
        }
        else {
            let form = document.getElementById("cart-donation-form") as HTMLFormElement;
            let formActionBaseUrl = (window as any).giftOptionBootstrap.formActionBaseUrl;
            form.action = formActionBaseUrl + "AddDonation";
            form.method = "POST";
            form.submit();
        }
    })
}

function inputValueGreaterThanZero(inputElement: HTMLInputElement): boolean {
    const value = parseFloat(inputElement.value);
    return value != null && !isNaN(value) && value > 0;

}
//End Gift Option